import SideBarTool from "@/commons/components/side-bar-tool";
import { Input, message } from "antd";
import { useState } from "react";
import './index.less'
import { LineType } from "pytha";
import { graphicStore } from "@/commons/store/graphic-store";
import { EXTRA_CTRL_TYPE } from "@/commons/enums/extra-control-code";
import { LayerType } from "@/commons/enums/layer-type";
import genUUID from "@/commons/utils/gen-uuid";
import { Layer } from "@/commons/interface/geometry/layer";
import { saveLayer } from "@/api/geometry/layer";
import { EXTRA_SINGAL } from "@/commons/enums/extra-singal";
import { useParams } from "react-router-dom";

export function FireShutterPanel() {
    const { projectUuid, modelUuid } = useParams();
    const [width, setWidth] = useState<number>(1600); // 卷帘门宽
    const [radius, setRadius] = useState<number>(300); // 卷轴半径
    const [height, setHeight] = useState<number>(2000); // 卷帘门高
    const [opacity, setOpacity] = useState<string>('1'); // 不透明度

    const onAssembleDoor = () => {
        if (!!!width) {
            message.warning("请输入卷帘门宽");
            return;
        }
        if (!!!radius) {
            message.warning("请输入卷轴半径");
            return;
        }
        if (!!!height) {
            message.warning("请输入卷帘门高");
            return;
        }
        if (!!!opacity) {
            message.warning("请输入透明度");
            return;
        }
        if (+opacity < 0 || +opacity > 1) {
            message.warning("透明度应在0~1之间");
            return;
        }
        let initDoorData = {
            width: width,
            radius: radius,
            height: height,
            opacity: opacity,
        }
        if (!graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl || graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl.id !== EXTRA_CTRL_TYPE.ASSEMBLE_FIRE_SHUTTER) {
            // 激活布置防火卷帘的二级控制器
            graphicStore.extraContext.getCurrentViewEditor().cmdControl.activateSubCommandControl("ASSEMBLEFIRESHUTTER");
            let layerUuid = graphicStore.context.layerContext.layers?.find(item => item?.type === LayerType.FIRE_SHUTTER)?.uuid || null;
            if (!layerUuid) {
                // 不存在防火卷帘图层，新建图层
                let uuid = genUUID();
                let newLayer: Layer = {
                    uuid: uuid,
                    name: "防火卷帘",
                    color: "#6a655f",
                    lineWidth: 0.25,
                    lineType: LineType.BASE_LINE,
                    lock: false,
                    hidden: false,
                    projectUuid: projectUuid,
                    originLayer: false,
                    type: LayerType.FIRE_SHUTTER,
                };
                saveLayer(newLayer, projectUuid, modelUuid).then(res => {
                    if (res.status === 200) {
                        graphicStore.context.layerContext.addLayer(newLayer);
                        graphicStore.extraContext.listeners.getSignal(EXTRA_SINGAL.onAssembleFireShutter).dispatch({ ...initDoorData, layerUuid: newLayer.uuid });
                    }
                }).catch(err => {
                    message.error("无法置为防火卷帘图层");
                    console.log(err);
                    let currentLayerUuid = graphicStore.context.layerContext.currentLayerUuid;
                    graphicStore.extraContext.listeners.getSignal(EXTRA_SINGAL.onAssembleFireShutter).dispatch({ ...initDoorData, layerUuid: currentLayerUuid });

                })
            } else {
                graphicStore.extraContext.listeners.getSignal(EXTRA_SINGAL.onAssembleFireShutter).dispatch({ ...initDoorData, layerUuid: layerUuid });
            }
        }
    }


    return (
        <div className="side-bar-main">
            <SideBarTool
                activeBtnList={[]}
            />
            <div className="body">
                <div className="title">
                    防火卷帘
                </div>
                <div className="detail fire-shutter-panel">
                    <div className="row">
                        <div className="label">卷帘门宽:</div>
                        <Input
                            className="input-box"
                            value={width}
                            onChange={(e) => {
                                let value = e.target.value;
                                if (!isNaN(parseInt(value))) {
                                    setWidth(parseInt(value))
                                } else {
                                    if (value == '') {
                                        setWidth(null);
                                    } else {
                                        setWidth(0)
                                    }
                                }
                            }}
                            suffix="mm"
                        />
                    </div>
                    <div className="row">
                        <div className="label">卷轴半径:</div>
                        <Input
                            className="input-box"
                            value={radius}
                            onChange={(e) => {
                                let value = e.target.value;
                                if (!isNaN(parseInt(value))) {
                                    setRadius(parseInt(value))
                                } else {
                                    if (value == '') {
                                        setRadius(null);
                                    } else {
                                        setRadius(0)
                                    }
                                }
                            }}
                            suffix="mm"
                        />
                    </div>
                    <div className="row">
                        <div className="label">卷帘门高:</div>
                        <Input
                            className="input-box"
                            value={height}
                            onChange={(e) => {
                                let value = e.target.value;
                                if (!isNaN(parseInt(value))) {
                                    setHeight(parseInt(value))
                                } else {
                                    if (value == '') {
                                        setHeight(null);
                                    } else {
                                        setHeight(0)
                                    }
                                }
                            }}
                            suffix="mm"
                        />
                    </div>
                    <div className="row">
                        <div className="label">透明度（0~1）:</div>
                        <Input
                            className="input-box"
                            value={opacity}
                            onChange={(e) => {
                                let value = e.target.value
                                const reg = /^-?\d*(\.\d*)?$/;
                                if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                                    setOpacity(value)
                                }
                            }}
                        />
                    </div>
                    <div className="ope-area">
                        <div className="primary-btn" onClick={onAssembleDoor}>确定</div>
                        <div className="secondary-btn"><div className="text">取消</div></div>
                    </div>
                </div>
            </div>
        </div>
    )
}